import React from "react";
import { useDispatch } from "react-redux";
import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import { closeModal } from "#redux/slices/globalUISlice";
import UserCard from "#cards/UserCard";
import Modal from "./Modal";
import api from "#utils/api";
import ViewMoreButton from "#components/helpers/ViewMoreButton";
import { withFallback } from "vike-react-query";

const ViewMembersModal = ({ club, quest }) => {
  const dispatch = useDispatch();

  const membersQuery = useSuspenseInfiniteQuery({
    queryKey: club ? ["club", club.uuid, "members"] : ["quest", quest.uuid, "members"],
    queryFn: ({ pageParam }) =>
      api.get(
        club ? `/clubs/${club.uuid}/members?page=${pageParam}` : `/challenges/${quest.uuid}/members?page=${pageParam}`
      ),
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => (pages.length < lastPage.total_pages ? pages.length + 1 : undefined),
  });

  const members = membersQuery.data.pages.map((p) => p.members).flat();

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Modal isOpen>
      <div className="md:min-w-[500px]">
        <h2 className="mb-6">All {club ? "members" : "participants"}</h2>
        <div className="flex flex-col gap-4">
          {members?.map((user) => (
            <UserCard key={user.id} user={user} callback={handleClose} />
          ))}
          <ViewMoreButton {...membersQuery} />
        </div>
      </div>
    </Modal>
  );
};

export default withFallback(ViewMembersModal);
